import { QueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'

/**
 * lib/queryClient.ts
 * TanStack Query client singleton.
 * Pattern from react_sample: QueryClient lives in src/lib/, not src/config/.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime:            30_000,
      gcTime:               5 * 60_000,
      retry:                1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      onError: (error: unknown) => {
        const message =
          error instanceof Error ? error.message : 'An unexpected error occurred.'
        toast.error(message)
      },
    },
  },
})
